
























































import { Component, Vue, Ref, Watch, Inject } from 'vue-property-decorator';
import { Search } from '@/data/models/search.model';
import { User } from '@/data/models/user.model';
import InfoOperatore from './operatore/InfoOperatore.vue';
import OperatoreFilter from './OperatoreFilter.vue';
import OperatoreList from './OperatoreList.vue';
import StatOperatore from './operatore/StatOperatore.vue';
import store, { State } from '@/store';
import { UserService } from '@/data/services/user.service';
import { Stats } from '@/data/models/stats.model';
import TopstatsCounter from '@/@core/components/topstats/TopstatsCounter.vue';

@Component({
	components: {
		OperatoreList,
		InfoOperatore,
		StatOperatore,
		OperatoreFilter,
		TopstatsCounter
	},
})
export default class Operatori extends Vue {

	@Ref('list') list!: OperatoreList;
	@Ref('filter') filter!: OperatoreFilter;

	state!: State;
	stats: Stats[] = [];

	@Inject('UserService') userService!: UserService;

	constructor() {
		super();
		this.state = store;
	}

	@Watch('state.headquarter', { deep: true })
	onHQChange() {
		this.filter.reset();
		this.loadTopstats();
	}

	mounted() {
		this.filter.search();
		this.loadTopstats();
	}

	onSearch(event: Search) {
		this.list.advancedSearch = event;
		this.list.loadOperatori();
	}

	openOperatoreDetail(item: User) {
		const modal = this.$buefy.modal.open({
			parent: this,
			component: InfoOperatore,
			props: {
				operatore: item,
			},
			hasModalCard: true,
			canCancel: false,
			events: {
				save: () => {
					modal.close();
				},
			},
		});
	}

	openOperatoreStats(item: User) {
		this.$buefy.modal.open({
			parent: this,
			component: StatOperatore,
			props: {
				operatore: item,
			},
			hasModalCard: true,
			canCancel: false,
		});
	}

	openOperatoriStats() {
		this.$buefy.modal.open({
			parent: this,
			component: StatOperatore,
			hasModalCard: true,
			canCancel: false,
		});
	}

	loadTopstats() {
		this.userService.topstats(this.state.headquarter!.id).then((response) => {
			this.stats = response;
		}).catch(({ data }) => {
			if (data) {
				this.$buefy.notification.open({
					message: data.msg || data.internal,
					type: 'is-danger',
				});
			}
		});
	}

}
